import { render, staticRenderFns } from "./AppAlertComponent.vue?vue&type=template&id=79d846df&scoped=true&"
import script from "./AppAlertComponent.ts?vue&type=script&lang=ts&"
export * from "./AppAlertComponent.ts?vue&type=script&lang=ts&"
import style0 from "./AppAlertComponent.scss?vue&type=style&index=0&id=79d846df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d846df",
  null
  
)

export default component.exports